import { useAppSelector } from 'reduxTyped'
import { AutomationModalDataMissingError } from 'apps/cms/errors'
import { AutomationModalType, CmsModalsState } from 'apps/cms/store/lib/types'

export const useModalData = <ModalType extends AutomationModalType>({
  type,
}: {
  type: ModalType
}) => {
  const modalState = useAppSelector((state) => state.contentManagementSystem.modals[type].data)

  if (modalState === null) {
    throw new AutomationModalDataMissingError(type)
  }

  type Data = Pick<CmsModalsState, ModalType>[ModalType]['data']

  return modalState as NonNullable<Data>
}
